import React from "react"
import { Card, CardBody, Table, Badge, Placeholder } from "reactstrap"
import { withTranslation } from "react-i18next"

// Skeletons de carga para las vistas de validación (SV2).
// Usan <Placeholder> de reactstrap (shimmer Bootstrap), sin dependencias extra.

// Estatus del Trip (mismo orden que el backend arma las columnas del kanban).
// Se muestran ya con su etiqueta i18n; el count va como placeholder animado.
export const TRIP_STATUSES = [
  "PENDING", "ON_WAY", "PICKUP", "ACTIVE", "FINISHED", "DELETED",
]

const statusLabel = (t, s) => t(`TripStatus_${s}`) || t(s) || s

// Skeleton de la tabla del listado: N filas con celdas placeholder.
const ListSkeletonBase = ({ rows = 8, cols = 6 }) => (
  <Table className="table table-bordered mb-0">
    <tbody>
      {Array.from({ length: rows }).map((_, r) => (
        <tr key={r}>
          {Array.from({ length: cols }).map((__, c) => (
            <td key={c}>
              <Placeholder animation="glow" className="w-100">
                <Placeholder xs={c === cols - 1 ? 8 : 10} />
              </Placeholder>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </Table>
)

export const ListSkeleton = withTranslation()(ListSkeletonBase)

// Skeleton del kanban: una columna por estatus (con su etiqueta) + count
// placeholder y unas tarjetas fantasma dentro.
const KanbanSkeletonBase = ({ t, cardsPerColumn = 3 }) => (
  <div className="d-flex gap-3 pb-3" style={{ overflowX: "auto" }}>
    {TRIP_STATUSES.map((st) => (
      <div key={st} style={{ minWidth: 260, flex: "0 0 260px" }}>
        <Card className="h-100">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <strong>{statusLabel(t, st)}</strong>
              {/* Count como pill placeholder animado. */}
              <Badge color="light" pill>
                <Placeholder animation="glow" style={{ minWidth: 18, display: "inline-block" }}>
                  <Placeholder xs={12} />
                </Placeholder>
              </Badge>
            </div>
            <div className="d-flex flex-column gap-2">
              {Array.from({ length: cardsPerColumn }).map((_, i) => (
                <Card key={i} className="mb-0 border">
                  <CardBody className="p-2">
                    <Placeholder animation="glow">
                      <Placeholder xs={6} /> <Placeholder xs={4} className="float-end" />
                      <Placeholder xs={8} className="d-block mt-2" />
                    </Placeholder>
                  </CardBody>
                </Card>
              ))}
            </div>
          </CardBody>
        </Card>
      </div>
    ))}
  </div>
)

export const KanbanSkeleton = withTranslation()(KanbanSkeletonBase)
